export default {
  menu: {
    aiCustomerServiceSettings: '客服设置',
    aiCustomerServiceMeeting: '会话列表',
    smartConstruction: '智能体中心',
    agentManager: '智能体管理',
    workOrderList: '转人工工单',
    aiCustomerService: '智能客服',
    multiSourceFeedbackCheck: '多源反馈查询',
    productSettings: '产品设置',
    rolePermissions: '权限审批',
    memberManagement: '成员管理',
    systemSettings: '系统设置',
    questionnaireManagement: '问卷管理',
    feedbackSettings: '反馈设置',
    feedbackInquiry: '反馈查询',
    feedbackOperation: '反馈运营',
    personalCenter: '个人中心',
    feedbackStatistics: '反馈统计',
    problemFollowUp: '问题跟进',
    userVoice: '用户声音',
    dataInsight: '数据洞察',
    overview: '概览',
    autoMonitorSetting: '监测规则',
    laboratory: '实验功能',
    publicExploration: '舆情探索',
    loganalysis: '日志分析',
    aiLogAnalysis: 'AI日志分析',
    logDetail: '日志详情',
    alphaTasklist: '内部体验',
    betaTasklist: '众测任务',
    summaryFeedback: '问题汇总',
    modelManagement: '众测用例管理',
    exchangeProcessing: '兑换处理',
    feedbackLayout: '反馈看板',
    aiKnowledge: 'AI知识库',
    knowledgeCorpus: '智能客服语料',
    agentEvaluation: '智能体评估',
    smartClassify: '智能分类',
  },
};
